// media.type: "procedural" (built-in concept animation) | "video" | "image" | "embed" — swap src when final assets arrive.
// credit.kind: "concept" (x1025 visualisation) | "x1025" (x1025 footage).
// Every demo must respect one rule: nothing outside the ship manager's control (ports, cranes, other vessels, infrastructure) has to change.
export const DEMOS = [
  {
    id: "fleet-supervision",
    index: "01",
    title: "A fleet, supervised from shore",
    capability: "Connected fleet · Remote Operations Center",
    summary: "A harbour calls a ship on its usual radio channel. The ROC answers and agrees a new arrival time.",
    media: { type: "procedural", key: "fleet", src: null, poster: null },
    credit: { kind: "concept" },
    upcoming: [],
  },
  {
    id: "cargo-net",
    index: "02",
    title: "Cargo nets any crane hook can catch",
    capability: "Cargo handling · nobody on deck",
    summary: "Our nets hold their lifting eye open for a standard hook. The crane stays unchanged; nobody is needed on deck.",
    media: { type: "procedural", key: "net", src: null, poster: null },
    credit: { kind: "concept" },
    upcoming: [],
    note: "x1025 cargo-net concept in development",
  },
  {
    id: "fault-recovery",
    index: "03",
    title: "When something breaks at sea",
    capability: "Detect · switch to backup · repair",
    summary: "A pump fails. Its backup takes over while a robot repairs it. The ROC stays informed and the ship keeps going.",
    media: { type: "procedural", key: "robot", src: null, poster: null },
    credit: { kind: "concept" },
    upcoming: [],
  },
];
